export default __webpack_public_path__ + "static/media/legend_protected_nature_types.7602c8d6.png";